<template>
  <!-- 费用配置-封面 -->
  <div class="main-container">
    <div class="back-box" v-if="coverShowBack">
      <Button type="primary" class="back-btn" @click="backPage">返回</Button>
    </div>

    <div class="cover-container">
      <div class="cover-top">
        <img src="@/static/images/commission/cover-01.png" />
        <div class="text-box">
          <span class="title">费用配置</span>
          <span class="desc"
            >本功能用于给下级机构、业务员团队分配<span class="text-color">产品及其首年和续年的基础费用</span>。产品和费用从总部<span class="text-color"
              >逐级下放</span
            >到各个组织，可全部下放或部分下放。</span
          >
          <span class="desc"
            >系统支持<span class="text-color">直接配费</span>和<span class="text-color">模板配费</span>两种方式。首次配费，您可根据需要选择其中一种方式。</span
          >
        </div>
      </div>

      <div class="distribution-config distribution-bg">
        <img src="@/static/images/commission/cover-02.png" />
        <div class="text-box">
          <span class="title">直接分配产品和基础费用</span>
          <span class="desc">直接对单个机构/团队配置其可见的产品和费用。可以对单个产品进行费用调整，也可以通过批量配费一次对多个产品进行调整。</span>
        </div>
        <div class="btn distribution-btn-bg" @click="directFee">
          <a>直接配费</a>
        </div>
      </div>

      <div class="distribution-config config-bg">
        <img src="@/static/images/commission/cover-03.png" />
        <div class="text-box">
          <span class="title">使用模板工具配置产品和基础费用</span>
          <span class="desc"
            >模板配费是一种便捷配费方式。模板有<span class="text-color">所属机构</span>，在模板内配置一套完整的产品和费率，然后将该模板应用到该<span
              class="text-color"
              >所属机构</span
            >的多个下一级机构或团队，即可实现一次性对多个机构或团队的费用进行配置或修改。同时，使用了模板的机构或团队，可以随时<span class="text-color"
              >独立调整</span
            >其产品和费用，不会影响到其他使用该模板的组织。</span
          >
          <span class="desc1"
            >此外，创建模板时会自动生成<span class="text-color">新产品预设服务费</span
            >比例。如果后续有新产品加入模板，费率将按照该预设比例自动配费。该比例可随时修改。</span
          >
        </div>
        <div class="btn config-btn-bg" @click="templateFee">
          <a>模板配费</a>
        </div>
      </div>

      <div class="tips">
        <span>提示：总部可将下级机构获得的产品资源再次往下分配（即只能继续往下分配下级机构产品库中<span class="text-color">已有的</span>产品）。</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        coverShowBack:{
            default: false
        }
    },

  methods: {
    // 返回
    backPage() {
      this.$emit('on-back');
    },

    // 直接配费
    directFee() {
      if (this.$route.query.show == 1) {
        this.$router.go(-1);
      } else {
        this.$emit('on-direct');
      }
    },

    // 模板配费
    templateFee() {
      this.$emit('on-template');
    }
  }
};
</script>
<style lang="scss" scoped>
.text-color {
  color: #ff6600 !important;
}
.back-box {
  width: 100%;
  min-width: 1590px;
  display: flex;
  .back-btn {
    margin-left: auto;
    margin-right: 10px;
  }
}
.cover-container {
  padding: 15px 10px 10px 10px;
  min-width: 1600px;
  .cover-top {
    display: flex;
    padding: 30px 30px;
    border: 1px solid #eeeeee;
    border-radius: 10px;
    img {
      width: 55px;
      height: 44px;
    }
    .text-box {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 18px;
        color: #3c464f;
        font-weight: bold;
      }
      .desc {
        font-size: 14px;
        color: #3c464f;
      }
    }
  }
  .distribution-config {
    display: flex;
    margin-top: 20px;
    padding: 47px 40px;
    border-radius: 10px;
    position: relative;
    &.distribution-bg {
      background: linear-gradient(81deg, #e5f6ff 0%, #ffffff 100%);
    }
    &.config-bg {
      background: linear-gradient(86deg, #ebeeff 0%, #ffffff 100%);
    }
    img {
      width: 100px;
      height: 113px;
    }
    .text-box {
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 20px;
        color: #0062c4;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .desc {
        max-width: 1174px;
        font-size: 14px;
        color: #3c464f;
      }
      .desc1 {
        display: inline-block;
        margin-top: 10px;
        font-size: 14px;
        color: #3c464f;
      }
    }
    .btn {
      position: absolute;
      right: 40px;
      top: 50%;
      margin-top: -13px;
      width: 136px;
      height: 36px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.distribution-btn-bg {
        background: linear-gradient(80deg, #0093ff 0%, #00b1ff 100%);
      }
      &.config-btn-bg {
        background: linear-gradient(262deg, #4b9eff 0%, #3e5cff 100%);
      }
      a {
        display: block;
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .tips {
    margin-top: 20px;
    font-size: 12px;
    color: #727c8e;
  }
}
</style>
